export default {
  checkPrivilege: (name: string, type: string) => {
    const data = localStorage.getItem("info");
    const privileges = JSON.parse(data !== null ? data : "{}").user.privileges;
    let check = false;

    for (let index = 0; index < privileges.length; index++) {
      if (privileges[index].name == name && privileges[index].type == type) {
        check = true;
      }
    }

    return check;
  },
  checkFullPrivileges: (name: string) => {
    const data = localStorage.getItem("info");
    const privileges = JSON.parse(data !== null ? data : "{}").user.privileges;
    const types = ["C", "R", "U", "D"];
    let check = 0;

    for (let index = 0; index < privileges.length; index++) {
      if (privileges[index].name == name) {
        types.forEach((type: string) => {
          if (privileges[index].type == type) {
            check++;
          }
        });
      }
    }

    return check > 0 ? true : false;
  }
};
